module.exports = __webpack_public_path__ + "img/excel-icon.76a49255.svg";